// The player stays independent of how recommendations are fetched/prepared.
let continueQueue: (() => boolean) | null = null

export function registerContinuation(handler: () => boolean): () => void {
  continueQueue = handler
  return () => { if (continueQueue === handler) continueQueue = null }
}

export function requestContinuation(): boolean {
  return continueQueue?.() ?? false
}
